export const sv = {
  languages: {
    finland: "Finska",
    sweden: "Svenska",
    england: "Engelska",
    germany: "Tyska",
  },
  rowStatus: {
    new: "Ny",
    pending: "Under behandling",
    error: "Fel",
    active: "Aktiv",
    null: "",
  },
  common: {
    suppliers: "Leverantörer",
    letters: "Brev",
    logout: "Logga ut",
    servicedesk: "Kundtjänst",
    tos: "Användarvillkor",
    guide: "Användarguide",
  },
  login: {
    username: "Användarnamn",
    password: "Lösenord",
    login: "Logga in",
    info1: "Importera era leverantörer med fil eller från Apix system",
    info2:
      "Övervaka dina leverantörer och se om de skickar fakturor till den korrekta e-fakturaadressen",
    info3:
      "Informera era leverantörer om ändringar i er e-fakturaadress via brev eller email",
    wrongPass: "Felaktigt användarnamn eller lösenord",
    serviceDown: "Tjänsten är onåbar. Kontakta servicedesk@apixmessaging.se.",
    accountLocked: "Av säkerhetsskäl spärras koden efter 5 felaktiga inloggningsförsök. Ditt konto är låst i 5 minuter."
  },
  modal: {
    confirm: "Okej",
    cancel: "Avbryt",
    confirmSendLetter: "Vill du skicka ut {count} aviseringar?",
    confirmSending: "Bekräfta utskick",
    remove: "Bekräfta borttagning",
    stop: "Stopp",
  },
  letters: {
    select: "Välj brev",
    name: "Namn",
    remove: "Radera",
    removeAttachment: "Ta bort bilaga",
    update: "Spara",
    createNew: "Skapa ny",
    create: "Skapa",
    downloadPDF: "Ladda ner PDF",
    preview: "Förhandsvisning",
    updated: "Sparad",
    subject: "Ämne",
    errorUpdating: "Fel vid uppdatering",
    exampleSentSuccesful: "Test skickat",
    errorSendingExample: "Fel i testutskick",
    errorAdding: "Fel när brev tillades",
    errorRemoving: "Fel när brev togs bort",
    removeSuccessful: "Borttagningen lyckades",
    addSuccessful: "Brev skapat",
    sendTest: "Skicka test-email",
    confirmRemove: "Vill du ta bort brevet {name}?",
    confirmTest: "Skicka test-email till {email}?",
    userAddressMissing:
      "Adressen saknas för användaren. Uppdatera användarens adress i Fakturamappen Tools.",
    selectFile: "Välj bilaga (PDF)",
    attachmentInfo:
      "När ett email skickas kommer bilagan läggas till i meddelandet. När ett brev skickas kommer bilagan användas som brev.",
    attachmentInfo2:
      "Meddelandet kan skrivas på flera olika språk. Texten kommer väljas baserat på mottagarens språk.",
    attachment: "Bilaga",
    exampleEmail: "Email-adress",
  },
  supplier: {
    suppliers: "Leverantörer",
    name: "Namn",
    add: "Lägg till",
    address: "Adress",
    businessId: "Organisationsnummer",
    street1: "Gata 1",
    street2: "Gata 2",
    postOffice: "Stad",
    postalCode: "Postnummer",
    countryCode: "Land",
    email: "Email",
    print: "Brev",
    status: "Status",
    active: "Aktiv",
    new: "Ny",
    pending: "Under behandling",
    error: "Fel",
    updatedSupplier: "Sparad",
    updatedSuppliers: "Uppdaterade leverantörer: {count}",
    duplicates: "Duplicerad leverantör: {count}",
    removeSuccessful: "Borttagna leverantörer: {count}",
    fetched: "Listan uppdaterad",
    confirmRemove: "Önskar du ta bort {count} leverantörer?",
    cantSendAsEmail: "{name} kan inte skickas som email",
    containsAttachment: "{name} innehåller bilaga",
    all: "Alla",
    checkForm: "Formuläret är ogiltigt",
    addedSupplier: "Leverantör tillagd",
    addedSuppliers: "Tillagda leverantörer: {count}",
    operationFailed: "Åtgärden misslyckades",
    adder: "Lägg till",
    importer: "Importera",
    remover: "Ta bort",
    sender: "Skicka",
    main: "Status",
    deleteSupplier: "Ta bort leverantör",
    selectLetter: "-- Välj brev --",
    selectDeliveryMethod: "-- Välj leveransmetod --",
    sendLetter: "Skicka leverantörsbrev",
    invoiceCount: "Fakturor",
    lettersSent: "Brev",
    lastLetterSent: "Senaste brev",
    emailsSent: "Email",
    lastEmailSent: "Senaste email",
    language: "Språk",
    importSupplier: "Importera från fil",
    examples: "Ladda ner exempel",
    selectFile: "Välj fil",
    selectSuppliers: "Välj leverantörer",
    selectedSuppliers: "Valda {count} leverantörer",
    removeSuppliers: "Ta bort leverantörer",
    ofWhich: ", av vilka",
    inError: " {count} är felaktiga",
    invalidAddress: "(inkorrekt adress eller språk)",
    missingEmail: "(felaktigt email eller språk)",
    validSuppliers: "{count} är godkända",
    sending: "Skickar",
    sent: "Skickade {count}/{total}",
    failedSent: "Misslyckades",
    checkListing: "Kontrollera listan",
    import: "Importera från fil",
    importInstructions1:
      "Importera leverantörer från Excel- eller CSV-fil. Duplicerade organisationsnummer kommer inte läggas till.",
    importInstructions2:
      "Du kan också uppdatera leverantörer baserat på organisationsnummer för valda kolumner.",
    downloadExample: "Ladda ner CSV- och Excel-exempelfiler här",
    importSuppliers: "Importera från fil",
    errorFileType: "Felaktigt filformat",
    importFromSystem: "Importera från system",
    importInstructions3:
      "Saknade leverantörer kommer importeras från systemet.",
    importInstructions4: "Importen kan ta flera minuter.",
    importSuppliersFromSystem: "Importera från system",
    importingFromSystem: "Hämtar leverantörer",
    overwrite: "Skriv över baserat på organisationsnummer:",
    texts: {
      count: "Visar {from}-{to} av resultat|{count} resultat|Ett resultat",
      filter: "Filter:",
      filterPlaceholder: "Sök",
      limit: "Sidstorlek:",
      page: "Sida:",
      noResults: "Inga resultat",
      filterBy: "Sök med {column}",
      loading: "Söker...",
      defaultOption: "Välj {column}",
      columns: "Kolumner",
    },
    statusTexts: {
      active: "E-fakturor har mottagits från leverantören",
      new: "Inga e-fakturor har mottagits från leverantören",
      pending: "Leverantören har blivit informerad, e-fakturor väntas",
      error: "Brev har kommit efter att leverantören har blivit informerad",
    },
  },
};
